export default function isInSchedule(startAux, endAux, todayAux) {
  const start = new Date(startAux);
  const end = new Date(endAux);
  let today = new Date(Date.now());
  if (todayAux) {
    today = new Date(todayAux);
  }
  if (today >= start && today <= end) {
    return true;
  }
  return false;
}
